// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

window.Splide = Splide;

htmx.config.globalViewTransitions = true;

document.addEventListener('DOMContentLoaded', function () {
    // Additional Photos Slider
    const productPhotoSlider = document.querySelector('.splide.product-additional-photos-slider');
    if (productPhotoSlider) {
        new Splide(productPhotoSlider, {
            type: 'slide',
            rewind: true,
            gap: '50px',
            pagination: false,
            fixedWidth: '300px',            
            breakpoints: {
                1240: {
                    focus: 'center',
                }
            }
        }).mount();
    }
});
